import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-safety',
  templateUrl: './public-safety.component.html',
  styleUrls: ['./public-safety.component.scss']
})
export class PublicSafetyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
